import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { observer } from "mobx-react";

function FacilityOrderTemplatePreviewTemplate({ facilityOrderTemplatePreviewStore }) {
    const {   
        titleData, 
        facilityOrderTemplateItems
    } = facilityOrderTemplatePreviewStore;    
    return (
        <section>
                <div className='content__header'>
                    <h2>
                        Template: {titleData.templateId}
                    </h2>
                </div>
                <TemplateItemsTable 
					facilityOrderTemplateItems={facilityOrderTemplateItems}
				/>
        </section> 
    );
    
}

// Develop wrapped this class with `@observer`; the mobx-undecorate
// codemod stripped the decorator without converting to the new
// `observer(Component)` call form, so the table stopped subscribing
// to the observables it reads. Restore the wrap.
const TemplateItemsTable = observer(class TemplateItemsTable extends React.Component {
	constructor(props) {
		super(props);
	}

    render() {
	const { facilityOrderTemplateItems } = this.props;
	
	return(
        <table className="table--preview">
            <thead>
                <tr>
                    <th className="type--left">Item Id</th>
                    <th className="type--left">Item Name</th>
                    <th className="type--left">UOM</th>
                    <th className="type--left">Temp Qty</th>
                    <th className="type--left">SO Qty</th>
                    <th className="type--left">BQTY</th>
                    <th className="type--left">Procedure Code</th>
                </tr>
            </thead>
            <tbody>
                {facilityOrderTemplateItems.map((item) => {
                    return (<tr key={item.id} >
                        <td >
                            {
                                item.product && item.product.itemId
                            }
                        </td>
                        <td onClick={(e) => e.stopPropagation()}>
                            {item.product && item.product.description} 
                        </td>
                        <td >
                            {item.product && item.product.uoM}
                        </td>
                        <td className="table-col-input">
                            <input 
                                className="input--table input--inherit-color w--100 no-arrows"
                                value={item.templateQuantity} 
                                type="number"
                                min="0"
                            />
                        </td>
                        <td className="table-col-input">
                            <input 
                                className="input--table input--inherit-color w--100 no-arrows" 
                                value={item.orderQuantity} 
                                type="number"
                                min="0"
                            />
                        </td>
                        <td className="table-col-input">
                            <input 
                                className="input--table input--inherit-color w--100 no-arrows" 
                                value={item.billingQuantity} 
                                type="number"
                                min="0"
                            />
                        </td>
                        <td>
                            {item.procedureCode && item.procedureCode}
                        </td>						
                    </tr>);
                }
                )}
            </tbody>
    </table>
    );
	}
});

TemplateItemsTable.propTypes = {
	facilityOrderTemplateItems: PropTypes.object,
};

FacilityOrderTemplatePreviewTemplate.propTypes = {
    facilityOrderTemplatePreviewStore: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(FacilityOrderTemplatePreviewTemplate);
